class FacetsAjax extends HTMLElement {
  connectedCallback() {
    this.addEventListener("change", this.handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.handleChange);
  }

  handleChange = (event) => {
    const input = event.target.closest('input[type="checkbox"]');
    if (!input) return;

    const group = input.closest("[param]");
    const param = group?.getAttribute("param");
    const value = input.value;

    if (!param || !value) return;

    this.applyFilter(this.buildUrl(param, value, input.checked));
  };

  buildUrl(param, value, isChecked) {
    const url = new URL(window.location.href);
    url.searchParams.delete("page");

    const values = url.searchParams.getAll(param).filter(Boolean);

    let nextValues;
    if (isChecked) {
      nextValues = values.includes(value) ? values : [...values, value];
    } else {
      nextValues = values.filter((item) => item !== value);
    }

    url.searchParams.delete(param);
    nextValues.forEach((item) => url.searchParams.append(param, item));

    return url.toString();
  }

  async applyFilter(url) {
    this.classList.add("pointer-events-none");
    this.setAttribute("aria-busy", "true");

    try {
      const fetchUrl = new URL(url);
      const sectionId = document.querySelector("#product-grid")?.dataset.id;
      fetchUrl.searchParams.set("section_id", sectionId || "collection");

      const response = await fetch(fetchUrl, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      this.updateElements(doc);

      window.history.pushState({ path: url }, "", url);
      window.dispatchEvent(new CustomEvent("custom:facets:fetch:complete"));
    } catch (error) {
      console.error("Filter update failed:", error);
    } finally {
      this.classList.remove("pointer-events-none");
      this.removeAttribute("aria-busy");
    }
  }

  updateElements(doc) {
    const isFacetsMenuOpen =
      document.querySelector("#facets-menu")?.getAttribute("aria-hidden") ===
      "false";

    const currentPagination = document.querySelector("pagination-ajax");
    const updatedPagination = doc.querySelector("pagination-ajax");
    if (currentPagination && updatedPagination) {
      currentPagination.replaceWith(updatedPagination);
    } else if (currentPagination && !updatedPagination) {
      currentPagination.remove();
    }

    const currentFacets = document.querySelector("facets-ajax");
    const updatedFacets = doc.querySelector("facets-ajax");
    if (currentFacets && updatedFacets) {
      currentFacets.replaceWith(updatedFacets);
    }

    if (isFacetsMenuOpen) {
      const nextMenu = document.querySelector("#facets-menu");
      if (nextMenu) {
        nextMenu.setAttribute("aria-hidden", "false");
      }
    }
  }
}

if (!customElements.get("facets-ajax")) {
  customElements.define("facets-ajax", FacetsAjax);
}
